import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SiteModel, SiteType } from 'src/app/core/_models/site.model';
import { AppState } from 'src/app/core/_reducers';
import { ItemsClearAll } from 'src/app/core/_reducers/_actions/shopping-cart.actions';
import { currentSite } from 'src/app/core/_reducers/_selectors/site.selector';
import { clearJsonLocalStorage } from 'src/app/helpers/json.helpers';
import { SetUrlBack } from 'src/app/layout/_reducers/_actions/layout.actions';

@Component({
  selector: 'app-dialog-cancel-confirmation',
  templateUrl: './dialog-cancel-confirmation.component.html',
  styleUrls: ['./dialog-cancel-confirmation.component.scss']
})
export class DialogCancelConfirmationComponent implements OnInit {

  site: SiteModel = new SiteModel();
  private subscriptions: Subscription[] = []

  constructor(
    public dialogRef: MatDialogRef<DialogCancelConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private router: Router,
  ){ }

  ngOnInit() {
    this.subscriptions.push(
      this.store.pipe(select(currentSite))
        .subscribe(res => {
          this.site = res
        })
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  goHome(){
    if (this.site.type === SiteType.multiple) {
      this.store.dispatch(new ItemsClearAll())
      this.router.navigate(['/'])
      clearJsonLocalStorage('order_data')
      this.store.dispatch(new SetUrlBack({ url: null }))
    } else {
      this.router.navigate(['/screensaver'], { queryParams: { cleanCache: 'true' } })
    }
  }
}
